import Iscroll from 'iscroll';
import Pubsub from 'pubsub-js';
import Events from './Events';

class ScrollArea {

  constructor(elm) {
    this.elm = elm;
    this.content = this.elm.querySelector('[data-scrollarea-content]');

    this.verifyApplyScroll();
    this.onResizeWindow();
  }

  onResizeWindow() {
    Pubsub.subscribe(Events.WINDOW_RESIZE, this.verifyApplyScroll.bind(this));
  }

  verifyApplyScroll() {
    const sizeElement = this.elm.offsetHeight;
    const sizeContent = this.content.offsetHeight;
    const hasToApply = sizeContent > sizeElement;

    if (hasToApply && !this.scroll) {
      this.applyScroll();
    } else if (hasToApply && this.scroll) {
      this.refreshScroll();
    } else if (this.scroll) {
      this.scroll.destroy();
      this.scroll = null;
    }
  }

  applyScroll() {
    /* eslint-disable no-new */
    setTimeout(() => {
      this.scroll = new Iscroll(this.elm, {
        scrollbars: 'custom',
        mouseWheel: true,
        interactiveScrollbars: true,
        shrinkScrollbars: 'scale',
        fadeScrollbars: false,
        scrollX: true,
        disablePointer: true,
        disableTouch: false,
        disableMouse: true,
      });
    }, 0);
  }

  refreshScroll() {
    this.scroll.refresh();
  }
}

export default {
  create(selector) {
    const instances = [];
    const elms = document.querySelectorAll(selector);

    for (let i = 0; i < elms.length; i += 1) {
      instances.push(new ScrollArea(elms[i]));
    }

    return instances;
  },
};



// WEBPACK FOOTER //
// ./scripts/modules/ScrollArea.js